import LocalMasterDataService from "./LocalMasterDataService";

export default class DataService{
    constructor(gcid)
    {
        //this.configService = new ConfigService();
        //this.localStorageService = new LocalStorageService();
        this.gcid = gcid;
        this.localMasterDataService = new LocalMasterDataService();
        this.productsCatalg = null;
        this.commoditiesCatalog = null;
        this.poolsCatalog = null;
        this.locationsCatalog = null;


    }


    async loadCatalogs(gcid)
    {
        this.gcid = gcid;
        this.productsCatalog = (await this.localMasterDataService.fetchMasterCatalog(this.gcid, "productscatalog")).dataResult;
        this.commoditiesCatalog = (await this.localMasterDataService.fetchMasterCatalog(this.gcid, "commoditiescatalog")).dataResult;
        this.poolsCatalog = (await this.localMasterDataService.fetchMasterCatalog(this.gcid, "poolscatalog")).dataResult;
        this.locationsCatalog = (await this.localMasterDataService.fetchMasterCatalog(this.gcid, "warehousescatalog")).dataResult;
    }

    async loadLocationsCatalog(gcid)
    {
        this.gcid = gcid;
        var locationsCatalogResult = await this.localMasterDataService.fetchMasterCatalog(this.gcid, "warehousescatalog");
        this.locationsCatalog = locationsCatalogResult.dataResult;
    }


    
    fetchLocations(){
        return this.locationsCatalog.warehouses;
    }


    fetchLocation(locationId)
    {
        return this.locationsCatalog.warehouses.find(wh => wh.id === locationId);
    }

    fetchLocationByName(locationName)
    {
        return this.locationsCatalog.warehouses.find(wh => wh.warehouse.name === locationName);
    }

    static fetchLocationByCatAndName(locationsCatalog, locationName)
    {
        return locationsCatalog.warehouses.find(wh => wh.warehouse.name === locationName);
    }

    fetchLocationNames()
    {
        return this.locationsCatalog.warehouses.map(wh =>
            {
                return wh.warehouse.name;
            }
        );
    }



    fetchProduct(productSearch){
        //("Item Search Properties: ");
        //console.log(productSearch);
        // don't bother checking if we don't have values for any of these
        if (!productSearch.isValid()){
            console.warn("Not all properties required for search are filled in.");
            return null;
        }
        var result = this.productsCatalog.products.find(product => 
            product.commodity.id === productSearch.commodityId &&
            product.region.id === productSearch.regionId &&
            product.method.id === productSearch.methodId &&
            product.style.id === productSearch.styleId &&
            product.label.id === productSearch.labelId &&
            product.size.id === productSearch.sizeId 
            
        )
        //console.log("Product Search Result: ");
        //console.log(result);
        return result;
    }


    fetchOpenPoolOptList(locationInfo)
    {
        var locationAccessGroupId = locationInfo.accessGroup.id;
        var filteredPools = this.poolsCatalog.pools.filter(pl => 
            {
                var hasAllAccess = (pl.accessGroups[0].accessGroup.id === "0");
                var hasLocationAccessGroup = (pl.accessGroups.some(ag => ag.accessGroup.id === locationAccessGroupId));
                return ( hasAllAccess || hasLocationAccessGroup);
            }
        );
        return filteredPools.map(pl => {
            return {"value": pl.pool.pool.id, "label": pl.pool.pool.name}
        }).sort((a, b) => a.label.localeCompare(b.label));
    }

    fetchOpenPools()
    {
        return this.poolsCatalog;
    }

    fetchPool(poolId)
    {
        return this.poolsCatalog.pools.find(pl => pl.pool.pool.id === poolId);
    }


    fetchOpenBlockOptList(poolId, locationInfo){
        var pool = this.fetchPool(poolId);
        var locationAccessGroupId = locationInfo.accessGroup.id;
        // if the pool has a commodity assigned, then restrict blocks
        // JUST to that commodity
        var poolHasCommodity = (pool.pool.commodity.id !== "0");
        return pool.blocks.reduce(function(result, block) 
        {
            if ((!poolHasCommodity) || (pool.pool.commodity.id === block.commodity.id))
            {
                // check of block has access group location restrictions
                if 
                (
                    (!block.hasAccessGroups) || 
                    ((block.hasAccessGroups) && (block.accessGroups.some(a => a.accessGroup.id === locationAccessGroupId)) )
                )
                {
                    result.push({"value": block.block.id, "label": block.block.id + "-" + block.block.name});
            
                }
            }
            return result.sort((a, b) => a.label.localeCompare(b.label));
        }, []);
    }

    fetchBlock(poolId, blockId){
        var pool = this.fetchPool(poolId);
        return pool.blocks.find(bl => {
            return bl.block.id === blockId;
        });
    }

    fetchGrowerFromBlock(poolId, blockId)
    {
        var block = this.fetchBlock(poolId, blockId);
        var result = block.grower;
        return result;
    }

    fetchStyle(commodityId, styleId)
    {
        var comm = this.fetchCommodity(commodityId);
        return comm.stylesCatalog.find(styl => styl.style.id === styleId);
    }

    fetchSize(commodityId, styleId, sizeId){
        var styl = this.fetchStyle(commodityId, styleId);
        return styl.sizesCatalog.find(sz => sz.size.id === sizeId);
    }

    fetchCommodity(commodityId)
    {
        return this.commoditiesCatalog.commodities.find(comm => comm.commodity.id === commodityId);
    }


    fetchCommodityAttribOptList(commodityId, attribType){
        var comm = this.fetchCommodity(commodityId);
        var commAttribList = comm[attribType]; 
        return commAttribList.map(commAttrib => {
            return {"value": commAttrib.id, "label": commAttrib.name};
        }).sort((a, b) => a.label.localeCompare(b.label))
    }

    fetchCommodityAttribOptListFromCat(commodityId, catName, attribType){
        var comm = this.fetchCommodity(commodityId);
        var cat = comm[catName];
        return cat.map(catAttrib => {
            var commAttrib = catAttrib[attribType];
            return {"value": commAttrib.id, "label": commAttrib.name};
        }).sort((a, b) => a.label.localeCompare(b.label))
    }

    fetchCatAttribOptList(parentCat, catName, attribType){
        var cat = parentCat[catName];
        return cat.map(catAttrib => {
            var attrib = catAttrib[attribType];
            return {"value": attrib.id, "label": attrib.name};
        }).sort((a, b) => a.label.localeCompare(b.label))
    }

    fetchExtraProp(parentNd, propName)
    {
        var propList = parentNd["extraProps"].props;
        var prop = propList.find(pl => pl.name.toLowerCase() === propName.toLowerCase());
        return prop;
    }





    

}